// /Users/doris/Documents/marty/Ai-Projects/ReportReader/frontend/src/components/DriverAnalytic.jsx
import React, { forwardRef, useState } from "react";
import MvrScorer from "./MvrScorer";
import Violations from "./Violations";
import Messages from "./Messages";
import DriverBanner from "./DriverBanner"; // Import the new component
import Disclaimer from "./Disclaimer";
import { useSelector } from "react-redux";

// import { useAccount } from '../context/AccountContext';

{
  /*
  This component displays the driver's analytic report, including driving records,
  violations, and messages. It uses the MvrScorer component to score the driver's record
  and provides a banner with risk and score information.
  The component is designed to be responsive and includes a sticky banner for important
  information. It also handles loading states and account validation.
  The component is wrapped in a forwardRef to allow parent components to access the main
  element for scrolling or other interactions. showBanner is a prop that controls
  whether the banner is displayed, and scoreData contains the risk and score information. 
  It is displayed at the top of the page.scorerRef is used to reference the MvrScorer component.
*/
}
const DriverAnalytic = forwardRef(
  (
    {
      reportData,
      driver_id,
      onScoreUpdate,
      setSelectedKey,
      setSelectedValue,
      onRecordSelect,
      showBanner,
      scoreData,
      scorerRef,
      onToggleFilters,
    },
    mainRef,
  ) => {
    const { accountId, entityId } = useSelector((state) => state.account);
    // const { entityId, loading } = useAccount();
    const [loading, setLoading] = useState(false);
    // const [entityId, setEntityId] = useState(null);

    if (loading) {
      return (
        <div className="flex items-center justify-center h-screen">
          <div className="text-gray-500">Loading account information...</div>
        </div>
      );
    }

    // if (!entityId) {
    //   return (
    //     <div className="flex items-center justify-center h-screen">
    //       <div className="text-red-500">No entity found. Please return to login.</div>
    //     </div>
    //   );
    // }

    return (
      <main
        ref={mainRef}
        className="flex-1 overflow-y-auto no-scrollbar relative pt-2"
        style={{
          msOverflowStyle: "none",
          scrollbarWidth: "none",
          height: "100vh", // Use CSS instead of Tailwind for more reliable height
        }}
      >
        {/* Use the new DriverBanner component */}
        {showBanner && (
          <DriverBanner reportData={reportData} scoreData={scoreData} />
        )}

        {/* Main content with proper spacing */}
        <div className="space-y-4 px-4 pb-8">
          {" "}
          {/* Add pb-8 for bottom padding */}
          <div
            className="bg-white rounded-lg shadow-sm border border-gray-200"
            ref={scorerRef}
          >
            <Disclaimer />
            <MvrScorer
              data={reportData}
              driver_id={driver_id}
              account_id={accountId}
              sub_entity_id={"1"}
              onScoreUpdate={onScoreUpdate}
              onToggleFilters={onToggleFilters}
            />
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            <Violations
              data={reportData}
              driver_id={driver_id}
              account_id={accountId}
              setSelectedKey={setSelectedKey}
              setSelectedValue={setSelectedValue}
              onRecordSelect={onRecordSelect}
            />
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            <Messages data={reportData} />
          </div>
        </div>
      </main>
    );
  },
);

DriverAnalytic.displayName = "DriverAnalytic";

export default DriverAnalytic;
